module.exports = __webpack_public_path__ + "static/media/bus_ticket.2b1d3bef.svg";